// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2MeKB","label":"Section_label__4JCqi","contentWrap":"Section_contentWrap__19O8n","footer":"Section_footer__2IzQc","footerInner":"Section_footerInner__25yyF"};